export default "__VITE_ASSET__OzG47gFv__"